const errorHandler = (error, expired = false) => {
    
    const errorObj = {
      400: () => `O formato dos campos pode estar incorreto. Tente novamente ou contate a equipe de suporte.`,
      401: () => expired ? `Acesso expirado. ` : `Usuário e/ou senha incorretos. Se você esqueceu sua senha, entre em contato com o suporte para solicitar nova senha. `,
      403: () => `Você não possui permissão para acessar este recurso. `,
      404: () => `Recurso não encontrado. `,
      500: () => `Erro interno do servidor/API. Tente novamente ou contate a equipe de suporte. `,
      unhandledCode: (httpCode, details) => `Código HTTP: ${httpCode}. ${details ? 'Detalhes: ' + details : ''}`,
      serverUnavailable: () => `Servidor da API indisponível. Verifique sua conexão com a internet ou contate a equipe de suporte.`,
      timeout: () => `Tempo limite de conexão excedido. Verifique sua conexão com a internet e tente novamente.`,
      default: () => `Ocorreu um erro desconhecido. Entre em contato com a equipe de suporte. `
    }
    
    // Verificar se é um erro de rede (servidor desligado/indisponível)
    if (error && !error.response) {
      if (error.code === 'ECONNREFUSED' || error.code === 'ERR_NETWORK') {
        return errorObj.serverUnavailable()
      }
      if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
        return errorObj.timeout()
      }
      // Outros erros de rede
      return errorObj.serverUnavailable()
    }
    
    // Erros com response do servidor
    if(error && error.response) {
      if(errorObj[error.response.status]) {
        return errorObj[error.response.status]()
      } else {
        return errorObj.unhandledCode(error.response.status, error.response?.data?.message)
      }
    }
    
    return errorObj.default()
  }

  export default errorHandler
